import { render, staticRenderFns } from "./producer_cider_infos_card.vue?vue&type=template&id=84095248&scoped=true"
import script from "./producer_cider_infos_card.vue?vue&type=script&lang=js"
export * from "./producer_cider_infos_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84095248",
  null
  
)

export default component.exports